import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import {
	PageRequest,
	TableHeaderItem,
	TemplatesWithOptions
} from '@models/models';
import { Subject } from 'rxjs';
import { PaginationService } from '@services/pagination/pagination.service';

@Component({
	selector: 'dynamic-table',
	template: require('./dynamic-table.component.html'),
	styles: [require('./dynamic-table.component.scss')]
})
export class DynamicTableComponent implements OnInit, OnChanges, OnDestroy {
	@Input() templates: TemplatesWithOptions<object>;
	@Input() headerList: Array<TableHeaderItem>;
	@Input() pageRequest: PageRequest;
	@Output() updateTableParams: EventEmitter<PageRequest> = new EventEmitter();

	pageNumbers: Array<number> = [];
	totalItems: number;
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(private paginationService: PaginationService) {}

	ngOnInit(): void {
		this.updatePageRequestParams();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes.templates &&
			!changes.templates.isFirstChange() &&
			changes.templates.currentValue.items.length
		) {
			this.updatePageRequestParams();
		}
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	orderByField(field: string, isSortable: boolean): void {
		if (isSortable) {
			this.pageRequest.sortCriterias[0].fieldName = field;
			this.pageRequest.sortCriterias[0].sortAscending = !this.pageRequest
				.sortCriterias[0].sortAscending;
			this.updateTemplate(this.pageRequest);
		}
	}

	updateTemplate(data): void {
		this.updateTableParams.emit(data);
	}

	private updatePageRequestParams(): void {
		this.totalItems = this.templates.totalSize;

		this.pageNumbers = this.paginationService.calculatePageNumbers(
			this.totalItems,
			this.pageRequest.paging.pageSize
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/common/dynamic-table/dynamic-table.component.ts